import {Store,Module,ActionContext} from 'vuex'
interface SignalrState{
    abp:any,
    chatHub:any,
    messageBox:any,
}
class SignalrModel implements Module<SignalrState,any>{
    namespaced=true;
    state={
        abp: null,
        chatHub:null,
        messageBox: [],
    }
    actions={
        send(content:ActionContext<SignalrState,any>,payload:any) {
            console.log(payload)
            content.state.chatHub.invoke('sendMessage', payload.msg); // 发送消息到服务器
            console.log('send')
        },
        getMessage(content:ActionContext<SignalrState,any>,payload:any) { 
            content.state.chatHub.on('getMessage', function (message) { // 注册接收消息
                console.log(message)
                return message
            });
        },
        close(content:ActionContext<SignalrState,any>,payload:any){
            // content.state.websock.close()
        }
    };
    mutations={
        init(state:any) {
            // state.websock = new WebSocket("ws://192.168.1.194:3000/")
            var abp = window.abp
            state.chatHub = null;
            abp.event.on('abp.signalr.connected', function() { // 注册连接事件
                state.chatHub.invoke('sendMessage', "asdsadasdsadsa"); // 发送消息到服务器
            });
            //连接失败再次调用
            let timer = setInterval(()=>{
                signalrServe()
            },500)
            function signalrServe(){
                if(abp.signalr.hubs!==undefined){
                    abp.signalr.startConnection(abp.signalr.url, function (connection) {
                        state.chatHub = connection; // 保存引用到hub
                        connection.on('getMessage', function (message) { // 注册接收消息
                            state.messageBox.push(message)
                        });
                    });
                    clearInterval(timer)
                    console.log('init')
                }
            }
        }
    }
}
const signalrModel=new SignalrModel();
export default signalrModel